import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/tournee`;

const TOKEN_KEY = "tournee_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const ytId = (url) => {
  const m = String(url || "").match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  return m ? m[1] : "";
};

export const fmtErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Une erreur est survenue. Réessayez.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return String(d);
};

// SEO léger par page (title + meta description + Open Graph)
export const setMeta = (title, description) => {
  document.title = title;
  const set = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };
  set("name", "description", description);
  set("property", "og:title", title);
  set("property", "og:description", description);
};

export const downloadCsv = async (url, filename) => {
  const { data } = await axios.get(url, { headers: authHeaders(), responseType: "blob" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(data);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
};
